document.querySelectorAll('.RangeDouble').forEach((el) => {
    const style = getComputedStyle(el);
    const min = parseInt(style.getPropertyValue('--min') || 1);
    const max = parseInt(style.getPropertyValue('--max') || 23);

    const stepsEls = el.querySelectorAll('.RangeDouble__steps span');

    const slider = noUiSlider.create(el.querySelector('.RangeDouble__range'), {
        start: [min, max],
        step: 1,
        connect: true,
        range: {min, max},
    });


    slider.on('update', function ([minV, maxV]) {
        stepsEls.forEach((el, i) => {
            const n = i + min;
            el.classList.toggle('out', n < minV || n > maxV)
        })
    });

    stepsEls.forEach((el, i) => {
        el.addEventListener('click', () => {
            if(isDisabled()) return;
            const [minV, maxV] = slider.get();
            const n = i + min;
            if(n > maxV || Math.abs(minV - n) > Math.abs(maxV - n)) {
                slider.set([null, n]);
            }
            else {
                slider.set([n, null]);
            }
        });
    });

    function isDisabled() {
        return slider.target.hasAttribute('disabled');
    }
})
